import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class InvestorService {

  constructor(private httpService: HttpService) { }


  investorComplaint(investorObject) {

      var request = {
          URL: 'investor/addInvestorComplaintData',
          DATA: investorObject
      }
      return this.httpService.post(request);
  }

  getRegisterDirector(object) {
      var registerList = {
          URL: "investor/getInvestorComplaintList/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(registerList);

  }

  removeinvestordetails(_id) {
      var request = {
          URL: "investor/deletadetails/" + _id
      }
      return this.httpService.get(request);
  }

  updateinvestor(_id) {
      var editlist = {
          URL: "investor/editDetail/" + _id,
      }
      return this.httpService.get(editlist);
  }

  updateInvestorComplaints(object, id) {
      var request = {
          URL: "investor/updateinvestor/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }
  generateInvestorDocument(object) {
      var request = {
          URL: "investor/generateInvestorDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadInvestorFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "investor/downloadDocument/" + id + "/" + type + "/" + token;
  }
  downloadInvestorPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "investor/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
}